import { render } from "./StartSida.vue?vue&type=template&id=dbcafada"
import script from "./StartSida.vue?vue&type=script&lang=js"
export * from "./StartSida.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__